exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes PlayScore_fadeIn__2NRC7 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes PlayScore_fadeIn__2NRC7 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes PlayScore_fadeOut__1mHk4 {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes PlayScore_fadeOut__1mHk4 {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.PlayScore_playScore__3NkJz {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-flex: 1 1;\n          flex: 1 1; }\n  .PlayScore_playScore__3NkJz .PlayScore_team__3XkYb {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-align-items: center;\n            align-items: center; }\n    .PlayScore_playScore__3NkJz .PlayScore_team__3XkYb:first-child {\n      -webkit-flex-direction: row-reverse;\n              flex-direction: row-reverse; }\n    .PlayScore_playScore__3NkJz .PlayScore_team__3XkYb .PlayScore_score__39-xr {\n      min-width: 3ch; }\n    .PlayScore_playScore__3NkJz .PlayScore_team__3XkYb .PlayScore_logo__2iO68 {\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center center;\n      margin: 5px;\n      width: 30px;\n      height: 30px;\n      -webkit-flex-shrink: 0;\n              flex-shrink: 0; }\n  .PlayScore_playScore__3NkJz .PlayScore_vs__2RUkL {\n    padding: 5px; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"playScore": "PlayScore_playScore__3NkJz",
	"team": "PlayScore_team__3XkYb",
	"score": "PlayScore_score__39-xr",
	"logo": "PlayScore_logo__2iO68",
	"vs": "PlayScore_vs__2RUkL",
	"fadeIn": "PlayScore_fadeIn__2NRC7",
	"fadeOut": "PlayScore_fadeOut__1mHk4"
};